module.exports = __webpack_public_path__ + "static/media/trash.7b067f16.svg";